import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Film, LogOut } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to={user ? (user.role === "admin" ? "/admin" : "/dashboard") : "/"}
          className="flex items-center gap-2 group"
          data-testid="navbar-logo"
        >
          <Film className="w-6 h-6 text-gold transition-transform group-hover:rotate-12" />
          <span className="font-serif text-xl tracking-tight">İnce Fikirler</span>
          <span className="text-[10px] uppercase tracking-[0.25em] text-gold/80 mt-1">AI Studio</span>
        </Link>
        {user && (
          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <p className="text-sm text-white leading-tight">{user.name}</p>
              <p className="text-xs text-gold uppercase tracking-widest">
                {user.role === "admin" ? "Stüdyo" : "Müşteri"}
              </p>
            </div>
            <button
              onClick={handleLogout}
              data-testid="logout-button"
              className="p-2 rounded-md border border-white/15 text-white/70 hover:text-gold hover:border-gold/50 transition-colors"
              title="Çıkış"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
